// Module
var code = `<div class="form-group" ng-class="{'has-error': hasError()}">
    <label class="control-label" ng-show="showTitle()">{{form.title}}</label>

    <div class="dropdown">
        <a class="dropdown-toggle" id="{{form.uuid}}" role="button" data-toggle="dropdown" data-target="#" href="#">
            <div class="input-group">
                <input sf-field-model="replaceAll"
                       type="text" class="form-control" data-ng-model="\$\$value\$\$">
                <span class="input-group-addon"><i class="glyphicon glyphicon-calendar"></i></span>
            </div>
        </a>
        <ul class="dropdown-menu" role="menu" aria-labelledby="dLabel">
            <datetimepicker sf-field-model="replaceAll" data-ng-model="\$\$value\$\$"
                            data-datetimepicker-config="{
                                dropdownSelector: '#' + form.uuid
                            }"/>
        </ul>
    </div>
    <span class="help-block" sf-message="form.description"></span>
</div>`;
// Exports
module.exports = code;